/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type AfterViewInit, type OnInit, Component, Injector, Input, TemplateRef, ViewChild } from '@angular/core';
import { type ColumnDef, type TableConfig, I18nService, TableAbstract, UNPLACEHOLDER, UtilService } from '@dm/core';
import { eventType, infigo } from '@dm/live-material-infigo';
import { healthStatusE, LUN_SUBTYPE, runningStatusE } from 'app/common/constants';
import { type Lun } from 'app/common/types/mo';
import { SWITCH } from 'app/config';
import { FeatureConfig } from 'app/config/feature';
import { LunsConst } from 'app/feature/service/block-service/lun-group/luns.const';
import { type SearchObj } from 'app/feature/share/global-search/global-search-str.service';

import { InfigoService } from '../../../infigo.service';

@Component({
    selector: 'app-member-lun-table',
    templateUrl: './member-lun-table.component.html',
    styleUrls: ['../../resource.scss'],
})
export class MemberLunTableComponent extends TableAbstract<Lun> implements OnInit, AfterViewInit {
    @Input() data: Lun[];
    @Input() loading = false;
    @ViewChild('lunLinkTemp') lunLinkTemp: TemplateRef<any>;
    // 表格行配置对象
    tableColumnDefs: ColumnDef[];
    // 表格总配置对象
    tableConfig: TableConfig;
    // 健康状态
    healthStatusE = healthStatusE;
    // 运行状态
    runningStatusE = runningStatusE;
    jumpPath: SearchObj;
    usageValue = this.infigoService.usageValue;

    LUNSUBTYPE = LUN_SUBTYPE;
    Number = Number;
    SWITCH = SWITCH;
    FeatureConfig = FeatureConfig;

    constructor(
        private i18n: I18nService,
        private str: LunsConst,
        private infigoService: InfigoService,
        private utilService: UtilService,
        injector: Injector) {
        super(injector);
    }

    ngAfterViewInit(): void {
        this.initTable();
    }

    initBtns(): void {
    }

    initTable(): void {
        this.tableColumnDefs = [
            {
                field: 'NAME',
                header: this.i18n.get('common.name_column'),
                filterType: 'search',
                sortable: true,
                customTemplate: this.lunLinkTemp,
            },
            {
                field: 'WWN',
                header: this.i18n.get('storage.lun_view_summary_localWWN_label'),
                filterType: 'search',
                columnFilter: true,
                render: (value: string): string => value ?? UNPLACEHOLDER,
                hidden: true,
            },
            {
                field: 'CAPACITY',
                header: this.i18n.get('common.capacity_column'),
                minWidth: 130,
                hideTextTips: true,
                sortable: true,
                align: 'right',
                render: (data) => data.SUBTYPE === LUN_SUBTYPE.CUSTOM || data.SUBTYPE === LUN_SUBTYPE.COMPUTATIONALSTORAGE ?
                    data :
                    this.utilService.adaptUnit(data).label,
            },
            {
                field: 'HEALTHSTATUS',
                header: this.i18n.get('common.healthStatus_column'),
                filterType: 'dropdown',
                options: this.str.healthStatusOpts,
                render: (data, col) => col.options[data],
            },
            {
                field: 'RUNNINGSTATUS',
                header: this.i18n.get('common.runningStatus_column'),
                filterType: 'dropdown',
                options: this.str.runningStatusOpts,
                render: (data, col) => col.options[data],
            },
        ];

        this.tableConfig = {
            dataKey: 'ID',
            motion: false,
            rows: 5,
        };
    }

    jumpToPath(value: { [key: string]: any }): void {
        const routerEvent = this.infigoService.transformSearchParams(value);
        infigo.dispatch(eventType.CLICK_LIST_ITEM, routerEvent);
    }
}
